/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const TagIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M5.366 2.5A2.866 2.866 0 0 0 2.5 5.366V9.49c0 .76.302 1.488.84 2.026l9.151 9.152c.879.879 2.283 1.133 3.39.409a18 18 0 0 0 5.197-5.197c.724-1.108.47-2.511-.409-3.389L11.518 3.34A2.87 2.87 0 0 0 9.49 2.5zM6.44 7.515a1.075 1.075 0 1 0 0-2.15 1.075 1.075 0 0 0 0 2.15" clipRule="evenodd" /></svg>;
};
export default TagIcon;